import React from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { useUnitGet } from "hooks/citajteo/dl_unit/useUnitGet";
import UnitEditNav from "components/admin/common/dl_unit/nav/UnitEditNav";
import UnitPdfFileEdit from "components/admin/common/dl_unit/pdf/UnitPdfFileEdit";

const UnitPdfEdit: React.FC = () => {
  const { itemId = "" } = useParams<{ itemId: string }>();
  const unit = useUnitGet(itemId);

  if (!unit) {
    return null;
  }

  return (
    <Div>
      <UnitEditNav unit={unit} />
      {unit && <UnitPdfFileEdit unit={unit} />}
    </Div>
  );
};

export default UnitPdfEdit;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;
